import type { ReactElement } from 'react'

import { useTranslate } from '../../code-only/localization/index.ts'
import { Avatar, Button } from '../../components/index.ts'

type CompactHeaderContactButtonProps = { onContact: () => void }

export function CompactHeaderContactButton({ onContact }: CompactHeaderContactButtonProps): ReactElement {
  const translate = useTranslate()
  return (
    <Button
      variant="secondary"
      size="medium"
      avatar={<Avatar icon="comment-regular" />}
      ariaLabel={translate('contact_customer_support')}
      onClick={onContact}
    />
  )
}
